module.exports = __webpack_public_path__ + "static/media/maintenance coordinator.6163fa2f.svg";